import { render, staticRenderFns } from "./MensajeInicial.vue?vue&type=template&id=69ee61db&scoped=true"
import script from "./MensajeInicial.vue?vue&type=script&lang=js"
export * from "./MensajeInicial.vue?vue&type=script&lang=js"
import style0 from "./MensajeInicial.vue?vue&type=style&index=0&id=69ee61db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ee61db",
  null
  
)

export default component.exports